import PropTypes from "prop-types"
import React from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"

const sharedLinkStyle = css`
  display: inline-block;
  font-size: 1.2rem;
  font-family: ${props => props.theme.crockpot.secondFont};
  color: ${props => (props.$isAlt ? props.theme.crockpot.text : "#fff")};
  background: ${props =>
    props.$isAlt ? props.theme.crockpot.main : props.theme.crockpot.text};
  text-decoration: none;
  text-align: center;
  margin-top: 2rem;
  ${props => !props.$hasChild && `padding: 0.5rem 1rem;`}
  border-radius: 0.6rem;
  text-transform: uppercase;
  border: 0.2rem solid #fff;
  transition: all 200ms linear;

  @media (min-width: 769px) {
    font-size: ${props => (props.language === "de" ? "1.6rem" : "1.9rem")};
    line-height: 2rem;
    margin-top: 5rem;

    ${props => !props.$hasChild && `padding: 1rem 2rem;`}
  }

  &:hover {
    color: ${props =>
      props.$isAlt
        ? props.theme.crockpot.text
        : props.theme.crockpot.textSecond};
    background-color: #fff;
    border-color: ${props =>
      props.$isAlt
        ? props.theme.crockpot.text
        : props.theme.crockpot.textSecond};
  }

  ${props =>
    props.$isHidden &&
    `
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity:0;
    margin: 0 !important;
    cursor: pointer;
    z-index: 2;
  `}

  button {
    display: block;
    background: none;
    border: 0;
    padding: 0.5rem 1rem;
    cursor: pointer;

    @media (min-width: 769px) {
      padding: 1rem 2rem;
    }
  }
`

const StyledLinkButton = styled(props => <Link {...props} />)`
  ${sharedLinkStyle}
`

const StyledExternalLinkButton = styled.a`
  ${sharedLinkStyle}
`

const LinkButton = ({
  isExternal = false,
  title = ``,
  link = ``,
  isAlt = false,
  isHidden = false,
  className,
  hasChild,
}) => {
  return (
    <>
      {isExternal ? (
        <StyledExternalLinkButton
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={title}
          $isAlt={isAlt}
          className={className}
        >
          {title}
        </StyledExternalLinkButton>
      ) : (
        <StyledLinkButton
          to={link}
          aria-label={title}
          $isAlt={isAlt}
          $isHidden={isHidden}
          className={className}
          $hasChild={hasChild}
        >
          {title}
        </StyledLinkButton>
      )}
    </>
  )
}

LinkButton.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  link: PropTypes.string,
  className: PropTypes.string,
  isExternal: PropTypes.bool,
  isAlt: PropTypes.bool,
  isHidden: PropTypes.bool,
  hasChild: PropTypes.bool,
}

export default LinkButton
